module.exports = __webpack_public_path__ + "static/img/article-level-chart.cf11a0e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/article/article-level-chart.png
// module id = j/cV
// module chunks = 1